export default __webpack_public_path__ + "static/media/img-speed-score.f460dd37.svg";